<template>
    <td class="table-persona-email-cell">
        {{email}}
    </td>
</template>
<script>
import TableCellMixin from './TableCellMixin.js';

export default {
    mixins: [TableCellMixin],
    computed: {
        email() {
            return this.row.username || this.row.user?.email || this.row.userEmailAddress || this.row.collectionEmailAddress;
        },
    }
}
</script>
<style scoped lang="scss">
td {
    white-space: nowrap;
    text-transform: lowercase;
}
</style>